// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2QmLm","inner":"Footer_inner__1Xy2e","nextIcon":"Footer_nextIcon__21vkX","innerLeft":"Footer_innerLeft__1NA4D"};